var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAcademicSideBarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.5C21.2437 11.7102 18.2353 11.25 15 11.25C11.7647 11.25 8.75624 11.7102 6.25 12.5V16.875C8.75624 16.0853 11.7647 15.625 15 15.625C18.2353 15.625 21.2437 16.0853 23.75 16.875V12.5Z",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 16.25V18.779C23.75 21.4428 22.4599 23.9113 20.3515 25.2818L18.6015 26.4193C16.3847 27.8603 13.6153 27.8603 11.3985 26.4193L9.64854 25.2818C7.5401 23.9113 6.25 21.4428 6.25 18.779V16.25",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.5L25.1571 11.7589C26.736 10.7234 27.5254 10.2057 27.4994 9.46601C27.4734 8.72631 26.65 8.2763 25.0031 7.37626L19.0941 4.14695C17.0851 3.04899 16.0806 2.5 15 2.5C13.9194 2.5 12.9149 3.04899 10.9058 4.14695L4.99691 7.37626C3.35005 8.2763 2.52661 8.72631 2.50062 9.46601C2.47462 10.2057 3.26406 10.7234 4.84292 11.7589L6.25 12.5",
    stroke: "#4B5563",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAcademicSideBarIcon);
export default __webpack_public_path__ + "static/media/user-academic-side-bar-icon.b95d0a262f0326e0fe52c4b87fc53e8e.svg";
export { ForwardRef as ReactComponent };